import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SaleService } from 'src/app/service/sale.service';
import { ProductSold } from '../sale/productSold';
import { AreceberCliente } from './areceberCliente';
import { MatDialog } from '@angular/material/dialog';
import { AreceberDialogPagamentoComponent } from '../areceber-dialog-pagamento/areceber-dialog-pagamento.component';
import { ContaReceber} from '../conta-receber/contareceber';
import { SaleAReceber} from '../areceber-dialog-pagamento/saleAReceber';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-areceber-dialog-detalhe',
  templateUrl: './areceber-dialog-detalhe.component.html',
  styleUrls: ['./areceber-dialog-detalhe.component.scss']
})
export class AreceberDialogDetalheComponent {

  listAreceberCliente: AreceberCliente[] = [];

  ordemColunasTabela = ['created', 'product','quantity', 'amount','amount_paid'];

  constructor(
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<AreceberDialogDetalheComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private saleService: SaleService) {
      this.listaAReceberCliente(data.aReceber.id);
    }

  ngOnInit(): void {
  }

  listaAReceberCliente(id:number){
    this.saleService.listarAReceberCliente(id).subscribe((response) => {
      this.listAreceberCliente = response;
    });
  }

  load() {
    //Session storage salva os dados como string
    (sessionStorage.refresh == 'true' || !sessionStorage.refresh) && location.reload();
    sessionStorage.refresh = true;
  }

  openDialogPagamento(areceberCliente: ContaReceber) {
    let dialogRef = this.dialog.open(AreceberDialogPagamentoComponent, {
      width: '300px',
      data: {
        areceberCliente: areceberCliente
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      
      const saleAReceber = new SaleAReceber(               
        parseFloat(String(result.pago).replace(",", ".")),
        parseFloat(String(result.troco).replace(",", ".")),
        result.areceberCliente.id,
        result.payment.name
      );

      // salvar venda
      this.saleService.saveAreceber(saleAReceber).subscribe(resposta => {
        this.snackBar.open('Venda Atualizada com sucesso!', 'Sucesso', {
          duration: 2000
        })
        //limpar formulário
        this.load();
      }, errorResponse => {
        // exibir mensagem snackbar
        this.snackBar.open(errorResponse.error.message, 'ERRO', {
          duration: 2000
        })
      })
    });
  }  
  
}
